/**
 * @module
 * @description Base vendor module for the core theme libs js.
 */

import embeds from './embeds';
import forms from './forms';
import searchform from './searchform';
import socialShare from './social-share';
import skipLinkTop from './skip-link-top';
import sitewideText from './sitewide-text';

/**
 * @function init
 * @description Kick off this modules functions
 */

const init = () => {
	embeds();
	forms();
	searchform();
	socialShare();
	skipLinkTop();
	sitewideText();
};

export default init;
